<template>
  <main>
    <Banner />
    <SectionPromo />
    <SectionHowTo />
    <SectionDownload />
    <SectionFeedback />
    <SectionTariff />
  </main>
</template>

<script>
import Banner from './components/Banner.vue';
import SectionDownload from './components/SectionDownload.vue';
import SectionFeedback from './components/SectionFeedback.vue';
import SectionHowTo from './components/SectionHowTo.vue';
import SectionPromo from './components/SectionPromo.vue';
import SectionTariff from './components/SectionTariff/SectionTariff.vue';

export default {
  components: {
    Banner,
    SectionDownload,
    SectionFeedback,
    SectionHowTo,
    SectionPromo,
    SectionTariff,
  },
};
</script>

<style>
</style>
